"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _mobx = require("mobx");
var _state = require("@seedlang/state");
var _utils = require("@seedlang/utils");
var _constants = require("@seedlang/constants");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var TranslateCardWrapper = function TranslateCardWrapper(Component) {
  var _class, _class2, _descriptor, _descriptor2, _descriptor3;
  return (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    function _class2(props) {
      var _this;
      _classCallCheck(this, _class2);
      _this = _callSuper(this, _class2, [props]);
      _initializerDefineProperty(_this, "showHelp", _descriptor, _this);
      _initializerDefineProperty(_this, "initialVideoPlayFinished", _descriptor2, _this);
      _initializerDefineProperty(_this, "loadHelpWord", _descriptor3, _this);
      _this.setShowHelp = function (showHelp) {
        _this.showHelp = showHelp;
        if (showHelp) {
          _this.onShowHelp();
        } else {
          _this.onLeaveHelp();
        }
      };
      _this.onShowHelp = function () {
        _state.DeckUI.designateUiElementAsSeen('helpMe');
        if (_this.props.cardState) {
          _this.props.cardState.set('showHelp', true);
          _this.props.cardState.set('helpWasShown', true);
        }
      };
      _this.onLeaveHelp = function () {
        if (_this.props.cardState && (0, _utils.isPresent)(_this.props.cardState)) {
          _this.props.cardState.resetWithinCard();
        }
        if (_this.props.card.sentence && _this.props.card.sentence.state) {
          _this.props.card.sentence.state.reset();
        }
      };
      _this.onNextClick = function () {
        _this.removeOnboardingTips();
        _state.DeckUI.advanceCard(_this.props.card, _this.props.cardState, _this.props.userCard, {
          score: _constants.Constants.EASY_SCORE,
          xp: _state.DeckUI.adjustedDefaultXp,
          xpXPos: _state.DeckUI.layout.quarterDeckWidth * 1
        });
      };
      _this.advanceCard = function (card, cardState, userCard, params) {
        _this.removeOnboardingTips();
        _state.DeckUI.advanceCard(card, cardState, userCard, params);
      };
      _this.onClickHelpWord = function (wa) {
        _this.loadHelpWord = true;
        clearTimeout(_this.timeout);
        _this.helpWord = wa.word;
        _this.timeout = setTimeout(_this.setHelpWord, 750);
      };
      _this.setHelpWord = function () {
        _this.loadHelpWord = false;
        _this.props.cardState.set('helpWord', _this.helpWord);
      };
      _this.afterVideoPlayback = function () {
        _this.initialVideoPlayFinished = true;
        _state.DeckUI.playUserInputAfterRevealVideo(_this.props.card, _this.props.cardState);
      };
      _this.removeOnboardingTips = function () {
        if (_this.showReviewButtonOnboarding) {
          _state.DeckUI.designateUiElementAsSeen('helpMeOnboarding');
          _state.DeckUI.designateUiElementAsSeen('reviewButtonOnboarding');
        }
        if (_this.showShortcutsOnboarding) {
          _state.DeckUI.designateUiElementAsSeen('shortcutsOnboarding');
        }
      };
      _state.DeckUI.enrichSentence(_this.props.card);
      return _this;
    }
    _inherits(_class2, _React$Component);
    return _createClass(_class2, [{
      key: "expandedTargetSectionHeight",
      get: function get() {
        if (this.props.cardState.revealed && this.props.card.word) {
          if (this.props.card.word.isPhoneme || this.props.card.word.isGrapheme) {
            return _state.DeckUI.layout.heightForCardSections(4) + _state.DeckUI.layout.heightForCardSections(3);
          }
          return _state.DeckUI.layout.heightForCardSections(4);
        }
        return _state.DeckUI.layout.describeContentHeight;
      }
    }, {
      key: "showUnrevealedTranslateButtons",
      get: function get() {
        return !this.showHelp && !this.props.cardState.revealed;
      }
    }, {
      key: "helpVideoClip",
      get: function get() {
        return this.props.cardState.helpWord && this.props.cardState.helpWord.videoClip;
      }
    }, {
      key: "showEvaluationButtons",
      get: function get() {
        return this.props.cardState.revealed;
      }
    }, {
      key: "showVideoWithSupplement",
      get: function get() {
        return this.props.cardState.revealed;
      }
    }, {
      key: "showDeckSupplement",
      get: function get() {
        return this.hasSupplementMedia && !this.showHelp && this.props.cardState.revealed && (this.props.card.showSupplement || _state.DeckUI.reviewDeck);
      }
    }, {
      key: "hasSupplementMedia",
      get: function get() {
        return this.props.card && (this.props.card.hasSupplementImage || this.props.card.hasSupplementVideoClip);
      }
    }, {
      key: "supplementMaximized",
      get: function get() {
        if (!this.showDeckSupplement || !this.props.cardState.revealed && !this.showHelp) {
          return false;
        }
        if (!this.videoPossible) {
          return true;
        }
        return _state.DeckUI.user.supplementMaximized;
      }
    }, {
      key: "videoPossible",
      get: function get() {
        return _state.DeckUI.deckLoaded && (0, _utils.isPresent)(this.props.card) && this.props.card.hasTargetVideoClip;
      }
    }, {
      key: "possibleArrowBoxes",
      get: function get() {
        return ['read_aloud'];
      }
    }, {
      key: "disableRevealButton",
      get: function get() {
        return !this.props.inView || _state.DeckUI.canRecordMedia && !_state.DeckUI.userInputStore.hasFinishedRecording;
      }
    }, {
      key: "currentArrowBox",
      get: function get() {
        if (!this.props.cardState.revealed) {
          return 'read_aloud';
        }
      }
    }, {
      key: "showShortcutsOnboarding",
      get: function get() {
        return !_state.DeckUI.user.wasUiElementSeen('shortcutsOnboarding') && !this.showHelp;
      }
    }, {
      key: "showReviewButtonOnboarding",
      get: function get() {
        return !_state.DeckUI.user.wasUiElementSeen('reviewButtonOnboarding') && this.props.cardState.revealed;
      }
    }, {
      key: "cardTextBorderTopRadius",
      get: function get() {
        return !this.showHelp && (_state.DeckUI.layout.cardTextHasMinimumHeight || !this.props.cardState.revealed) ? 10 : 0;
      }
    }, {
      key: "cardTextBorderBottomRadius",
      get: function get() {
        return !_state.DeckUI.showNoUserInputBar && !_state.DeckUI.showUserInput ? 10 : 0;
      }
    }, {
      key: "showWordCard",
      get: function get() {
        return !this.showHelp && this.props.inView && this.props.card && this.props.card.sentence && this.props.card.sentence.state.selectedWordAssociationId;
      }
    }, {
      key: "showUserInput",
      get: function get() {
        return _state.DeckUI.canRecordMedia && _state.DeckUI.layout.showUserInput;
      }
    }, {
      key: "icons",
      get: function get() {
        if (this.showWordCard) {
          return [];
        }
        var ary = [];
        if ((0, _utils.isPresent)(this.props.card.grammarTipMd)) {
          ary.push('grammarTip');
        }
        if (_state.DeckUI.reviewDeck && this.props.cardState.revealed) {
          ary.push('reviewDetails');
        }
        if (!_state.DeckUI.reviewDeck && this.props.cardState.revealed) {
          ary.push('toggleReview');
        }
        if (this.props.cardState.revealed && _state.DeckUI.showDeckGrammarIcon) {
          ary.push('deckGrammar');
        }
        if (this.props.cardState.revealed) {
          ary.push('cardComments');
        }
        if (_state.DeckUI.reviewDeck && (this.props.cardState.revealed || this.props.card.showNoteBeforeReveal)) {
          ary.push('cardNote');
        }
        return ary;
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          helpVideoClip: this.helpVideoClip,
          showUnrevealedTranslateButtons: this.showUnrevealedTranslateButtons,
          showEvaluationButtons: this.showEvaluationButtons,
          showVideoWithSupplement: this.showVideoWithSupplement,
          showHelp: this.showHelp,
          setShowHelp: this.setShowHelp,
          showDeckSupplement: this.showDeckSupplement,
          supplementMaximized: this.supplementMaximized,
          possibleArrowBoxes: this.possibleArrowBoxes,
          currentArrowBox: this.currentArrowBox,
          cardTextBorderTopRadius: this.cardTextBorderTopRadius,
          cardTextBorderBottomRadius: this.cardTextBorderBottomRadius,
          disableRevealButton: this.disableRevealButton,
          showWordCard: this.showWordCard,
          showUserInput: this.showUserInput,
          onNextClick: this.onNextClick,
          afterVideoPlayback: this.afterVideoPlayback,
          initialVideoPlayFinished: this.initialVideoPlayFinished,
          advanceCard: this.advanceCard,
          icons: this.icons,
          loadHelpWord: this.loadHelpWord,
          onClickHelpWord: this.onClickHelpWord,
          expandedTargetSectionHeight: this.expandedTargetSectionHeight
        }));
      }
    }]);
  }(_react["default"].Component), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "showHelp", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "initialVideoPlayFinished", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "loadHelpWord", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _applyDecoratedDescriptor(_class2.prototype, "expandedTargetSectionHeight", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "expandedTargetSectionHeight"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showUnrevealedTranslateButtons", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showUnrevealedTranslateButtons"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "helpVideoClip", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "helpVideoClip"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showEvaluationButtons", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showEvaluationButtons"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showVideoWithSupplement", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showVideoWithSupplement"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showDeckSupplement", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showDeckSupplement"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "hasSupplementMedia", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "hasSupplementMedia"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "supplementMaximized", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "supplementMaximized"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "videoPossible", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "videoPossible"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "possibleArrowBoxes", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "possibleArrowBoxes"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "disableRevealButton", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "disableRevealButton"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "currentArrowBox", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "currentArrowBox"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showShortcutsOnboarding", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showShortcutsOnboarding"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showReviewButtonOnboarding", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showReviewButtonOnboarding"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "cardTextBorderTopRadius", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "cardTextBorderTopRadius"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "cardTextBorderBottomRadius", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "cardTextBorderBottomRadius"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showWordCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showWordCard"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showUserInput", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showUserInput"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "icons", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "icons"), _class2.prototype), _class2)) || _class;
};
TranslateCardWrapper.displayName = 'TranslateCardWrapper';
var _default = exports["default"] = TranslateCardWrapper;